import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { withIntent } from '../../../util/hoc/withIntent.js';
import { DisableContext } from '../../../contexts/Disable/DisableContext.js';
import { useButtonBase } from './hooks/useButtonBase.js';

var _excluded = ["children"];
var ButtonBaseComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useButtonBase = useButtonBase(props, ref),
    buttonProps = _useButtonBase.buttonProps,
    disableContextValues = _useButtonBase.disableContextValues;
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, buttonProps), /*#__PURE__*/React.createElement(DisableContext.Provider, {
    value: disableContextValues
  }, children));
});
ButtonBaseComponent.displayName = 'ButtonBase';
var ButtonBaseComponentWithIntent = withIntent(ButtonBaseComponent);
var ButtonBase = /*#__PURE__*/React.memo(ButtonBaseComponentWithIntent);

export { ButtonBase, ButtonBaseComponentWithIntent as ButtonBaseComponent };
//# sourceMappingURL=ButtonBase.js.map
